import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const toBytes = (value) => {
  const pad = '='.repeat((4 - (value.length % 4)) % 4);
  const raw = atob((value + pad).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...raw], (c) => c.charCodeAt(0));
};

export const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
export const pushSupported = () => 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

export const pushState = () => {
  if (!pushSupported()) return 'unsupported';
  if (isIOS() && !isStandalone()) return 'ios_install_required';
  return Notification.permission; // granted | denied | default
};

export const getSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration('/');
  return reg ? reg.pushManager.getSubscription() : null;
};

export const enablePush = async (authHeader) => {
  const state = pushState();
  if (state === 'unsupported') throw new Error('unsupported');
  if (state === 'ios_install_required') throw new Error('ios_install_required');
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('denied');
  const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
  await navigator.serviceWorker.ready;
  const { data } = await axios.get(`${API}/push/vapid-public-key`);
  const existing = await reg.pushManager.getSubscription();
  const sub = existing || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toBytes(data.public_key) }));
  await axios.post(`${API}/push/subscribe`, { ...sub.toJSON(), user_agent: navigator.userAgent.slice(0, 200) }, { headers: { Authorization: authHeader } });
  return sub;
};

export const disablePush = async (authHeader) => {
  const sub = await getSubscription();
  if (!sub) return;
  await axios.post(`${API}/push/unsubscribe`, { endpoint: sub.endpoint }, { headers: { Authorization: authHeader } });
  await sub.unsubscribe();
};
